import { useState, useEffect } from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import { HERO_SLIDES, GALLERY_IMAGES, SERVICES_DATA, TRAINERS_DATA, STATS } from '../data';
import './Home.css';

export default function Home({ setPage }) {
  const [slide, setSlide] = useState(0);
  const ref = useScrollReveal();

  useEffect(() => {
    const id = setInterval(() => setSlide((s) => (s + 1) % HERO_SLIDES.length), 5500);
    return () => clearInterval(id);
  }, []);

  const go = (p) => { setPage(p); window.scrollTo({ top: 0, behavior: 'smooth' }); };
  const cur = HERO_SLIDES[slide];

  return (
    <div ref={ref}>
      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-slides">
          {HERO_SLIDES.map((s, i) => (
            <div
              key={i}
              className={`hero-slide${i === slide ? ' active' : ''}`}
              style={{ backgroundImage: `url('${s.bg}')` }}
            />
          ))}
        </div>
        <div className="hero-overlay" />
        <div className="hero-grain" />

        <div className="hero-content">
          <div className="hero-tag">{cur.tag}</div>
          <h1 className="hero-h1">
            {cur.heading}
            <em>{cur.accent}</em>
          </h1>
          <p className="hero-p">{cur.sub}</p>
          <div className="hero-btns">
            <button className="btn-primary" onClick={() => go('Membership')}>Join Now →</button>
            <button className="btn-ghost" onClick={() => go('About')}>Explore More</button>
          </div>
        </div>

        <div className="hero-nav">
          {HERO_SLIDES.map((_, i) => (
            <div key={i} className={`hero-dot${i === slide ? ' active' : ''}`} onClick={() => setSlide(i)} />
          ))}
        </div>
        <div className="hero-counter">
          0{slide + 1}<br /><span>/ 0{HERO_SLIDES.length}</span>
        </div>
        <div className="hero-scroll">
          <div className="hero-scroll-line" />
          <div className="hero-scroll-text">Scroll</div>
        </div>
      </section>

      {/* ── MARQUEE ── */}
      <div className="marquee-wrap">
        <div className="marquee-inner">
          {[...Array(2)].map((_, r) =>
            ['Weight Training','Cardio','Yoga','HIIT','Boxing','Nutrition','Personal Training','CrossFit','Recovery','Spinning'].map((t, i) => (
              <div className="marquee-item" key={`${r}-${i}`}>
                {t}<span className="marquee-sep" />
              </div>
            ))
          )}
        </div>


      </div>

      {/* ── NUMBERS ── */}
      <div className="numbers-band">
        <div className="section-inner">
          <div className="nb-grid">
            {STATS.map(([n, l], i) => (
              <div className="nb-item fade-up" key={l} style={{ transitionDelay: `${i * 0.1}s` }}>
                <span className="nb-num">{n}</span>
                <div className="nb-label">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── GALLERY STRIP ── */}
      <div className="gallery-strip">
        {GALLERY_IMAGES.map((g, i) => (
          <div className="gs-item" key={i}>
            <img src={g.src} alt={g.label} className="gs-img" />
            <div className="gs-overlay" />
            <div className="gs-label">{g.label}</div>
          </div>
        ))}
      </div>

      {/* ── ABOUT PREVIEW ── */}
      <section className="section" style={{ background: 'var(--black2)' }}>
        <div className="section-inner">
          <div className="about-preview-grid">
            <div className="fade-left about-img-wrap">
              <img
                src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=700&q=80"
                alt="Training"
                className="about-preview-img"
              />
              {/* <div className="about-hex-badge">
                <span className="badge-num">15</span>
                <span className="badge-text">Years Elite</span>
              </div> */}
              <div className="about-border-deco" />
            </div>

            <div className="fade-right">
              <div className="sec-eyebrow">Who We Are</div>
              <h2 className="sec-title">MORE THAN A GYM.<br /><span className="acc">A WAY OF LIFE.</span></h2>
              <div className="divider" />
              <p className="sec-desc">Founded in 01/04/2025, Fitness King has grown from a single training floor into one of the most respected premium fitness destinations in Jagamara, Bhubaneswar.</p>
              <p className="sec-desc" style={{ marginTop: '1rem' }}>Our 25,000 sq ft facility is built with one goal in mind: to give you every advantage in achieving peak physical performance.</p>

              <div className="feat-grid">
                {[
                  ['⚡','Elite Equipment','$2M+ in premium Technogym machines'],
                  ['🏆','Award-Winning Coaches','50+ certified specialists'],
                  ['🌐','500+ Community','A network built on progress'],
                ].map(([ic, tit, sub]) => (
                  <div className="feat-item" key={tit}>
                    <div className="feat-icon">{ic}</div>
                    <div className="feat-title">{tit}</div>
                    <div className="feat-sub">{sub}</div>
                  </div>
                ))}
              </div>
              <button className="btn-primary" style={{ marginTop: '2rem' }} onClick={() => go('About')}>
                Our Full Story →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICES PREVIEW ── */}
      <section className="section">
        <div className="section-inner">
          <div className="text-center fade-up" style={{ marginBottom: '4rem' }}>
            <div className="sec-eyebrow" style={{ justifyContent: 'center' }}>What We Offer</div>
            <h2 className="sec-title">WORLD-CLASS <span className="acc">SERVICES</span></h2>
            <div className="divider center" />
          </div>
        </div>
        <div className="service-grid" style={{ maxWidth: '1400px', margin: '0 auto' }}>
          {SERVICES_DATA.slice(0, 4).map((s, i) => (
            <div
              className={`svc-card fade-up delay-${i + 1}`}
              key={s.title}
              onClick={() => go('Services')}
            >
              <div className="svc-bg" style={{ backgroundImage: `url('${s.bg}')` }} />
              <div className="svc-gradient" />
              <div className="svc-content">
                <div className="svc-icon-wrap">{s.icon}</div>
                <div className="svc-title">{s.title}</div>
                <div className="svc-desc">{s.desc}</div>
                <div className="svc-link">Learn More <span>→</span></div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center" style={{ marginTop: '3rem' }}>
          <button className="btn-ghost fade-up" onClick={() => go('Services')}>View All Services →</button>
        </div>
      </section>

      {/* ── TRAINERS PREVIEW ── */}
      <section className="section" style={{ background: 'var(--black2)', paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="section-inner">
          <div className="trainers-header">
            <div className="fade-up">
              <div className="sec-eyebrow">The Team</div>
              <h2 className="sec-title">MEET THE <span className="acc">COACHES</span></h2>
            </div>
            <button className="btn-ghost fade-up delay-2" onClick={() => go('Trainers')}>All Trainers →</button>
          </div>
          <div className="trainer-grid" style={{ marginTop: '3rem' }}>
            {TRAINERS_DATA.slice(0, 4).map((t, i) => (
              <div className={`tr-card fade-up delay-${i + 1}`} key={t.name}>
                <img src={t.img} alt={t.name} className="tr-img" />
                <div className="tr-overlay" />
                <div className="tr-info">
                  <div className="tr-name">{t.name}</div>
                  <div className="tr-spec">{t.spec}</div>
                  <div className="tr-bio">{t.bio}</div>
                  <div className="tr-socials">
                    {['𝕏','in','ig'].map((s) => <a key={s} className="tr-social">{s}</a>)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section className="cta-banner">
        <div className="cta-glow" />
        <div className="section-inner text-center">
          <div className="fade-up">
            <div className="sec-eyebrow" style={{ justifyContent: 'center' }}>Limited Spots Available</div>
            <h2 className="cta-title">START YOUR <span className="acc">TRANSFORMATION</span></h2>
            <p className="sec-desc" style={{ margin: '0 auto 2.5rem', textAlign: 'center' }}>
              Start your fitness journey today with a free first month and a complimentary personal training session. No contracts. No excuses—just results.
            </p>
            <div className="cta-btns">
              <button className="btn-primary" style={{ fontSize: '1rem', padding: '18px 48px' }} onClick={() => go('Membership')}>
                View Plans →
              </button>
              <button className="btn-ghost" onClick={() => go('Contact')}>Book a Free Tour</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
